module.exports = __webpack_public_path__ + "img/AI.8109b68a.jpg";